export enum PayoutStatus {
    Pending = 'pending',
    Ready = 'ready',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
    Scheduled = 'scheduled',
    Initiated = 'initiated',
    Deposited = 'deposited',
}
